import { UIHeading4 } from '@cian/ui-kit';

import { type ReactNode } from 'react';

import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

export function SubtitleContainer(): ReactNode {
  const { subtitle } = useCardOfferDataContext();

  if (!subtitle) {
    return null;
  }

  return <UIHeading4 as="h3">{subtitle}</UIHeading4>;
}
